module.exports = __webpack_public_path__ + "assets/img/teacher (44).1b2a0ea3.png";